import { useEffect, useRef } from "react";
import { api } from "../lib/api";



const urlBase64ToUint8Array = (base64String: string): Uint8Array => {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  return new Uint8Array([...rawData].map((char) => char.charCodeAt(0)));
}



export const usePushSubscribe = (enabled: boolean) => {
  const subscribed = useRef(false);

  useEffect(() => {
    if (!enabled || subscribed.current) return;
    if (!("serviceWorker" in navigator) || !("PushManager" in window)) return;

    const subscribe = async () => {
      try {
        const reg = await navigator.serviceWorker.ready;
        const sub = await reg.pushManager.getSubscription();
        if (sub) {
          subscribed.current = true;
          return;
        }

        const { data } = await api.get<{ publicKey: string | null }>(
          "/notifications/push/vapid-public",
        );
        if (!data?.publicKey) return;

        const permission = await Notification.requestPermission();
        if (permission !== "granted") return;

        const newSub = await reg.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: urlBase64ToUint8Array(data.publicKey)
            .buffer as ArrayBuffer,
        });

        const payload = {
          endpoint: newSub.endpoint,
          keys: {
            p256dh: btoa(
              String.fromCharCode(...new Uint8Array(newSub.getKey("p256dh")!)),
            ),
            auth: btoa(
              String.fromCharCode(...new Uint8Array(newSub.getKey("auth")!)),
            ),
          },
        };

        await api.post("/notifications/push/subscribe", payload);
        subscribed.current = true;
      } catch {
        // Silently fail - push may not be configured
      }
    };

    subscribe();
  }, [enabled]);
}
